import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import CarouselSlider from '../../components/carouselSlider';
import {pxToEm} from '../../components/globalStyles';
import Testimonial from '../../components/testimonial';
import {ALL_TESTIMONIALS} from '../../data/customerData';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledH2 = styled.h2`
  font-size: ${pxToEm(24)}em;
  color: ${baseVariables.colors.midnight};
`;

const StyledCarouselSliderWrapper = styled.div`
  margin-top: ${pxToEm(98)}em;
  width: 100%;
  max-width: ${pxToEm(1039)}em;
`;

//#endregion

const PeopleSaySection: React.FunctionComponent = () => {
  const feedbackData = ALL_TESTIMONIALS.map((testimonial, i) => (
    <Testimonial key={`testimonial-${i}`} testimonial={testimonial} />
  ));

  return (
    <StyledWrapperDiv>
      <StyledH2>What people are saying about us</StyledH2>
      <StyledCarouselSliderWrapper>
        <CarouselSlider speed={1000} infinite={true} autoplay={true} autoplaySpeed={5000} pauseOnHover={true}>
          {feedbackData}
        </CarouselSlider>
      </StyledCarouselSliderWrapper>
    </StyledWrapperDiv>
  );
};

export default PeopleSaySection;
